import { render, staticRenderFns } from "./DeliveryNoteApplication.vue?vue&type=template&id=74b27ba6&"
import script from "./DeliveryNoteApplication.vue?vue&type=script&lang=js&"
export * from "./DeliveryNoteApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports